import { DollarSign, KeyRound, Network, TrendingUp, User } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { costsWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  costsWeb,
  {
    CostsOverviewPage: () => import('./CostsOverviewPage'),
    CostsOverviewPagePreview: () => import('./CostsOverviewPagePreview'),
    CostsUserDetailPage: () => import('./CostsUserDetailPage'),
    CostsKeyDetailPage: () => import('./CostsKeyDetailPage'),
    CostsKeyRecordsPage: () => import('./CostsKeyRecordsPage'),
    CostsProviderDetailPage: () => import('./CostsProviderDetailPage'),
    CostsCategoryDetailPage: () => import('./CostsCategoryDetailPage'),
    CostsLabelDetailPage: () => import('./CostsLabelDetailPage'),
    CostsKeyPreview: () => import('./CostsKeyPreview'),
    MyCostsSection: () => import('./MyCostsSection'),
    SpendHeatmapSection: () => import('./SpendHeatmapSection'),
  },
  {
    icons: { DollarSign, KeyRound, Network, TrendingUp, User },
  },
);
